<app-spinner *ngIf="loadingFacilities"></app-spinner>

<div *ngIf="facilities && meta.totalItems > 0">
  <form name="form" novalidate>
    <div [hidden]="showListActions">
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-addon">
            <i class="fa fa-search" title="{{ 'NAME' | translate }}"></i>
          </span>
          <app-search-text-input
            [field]="'by_name'"
            [value]="filterCriteria.by_name"
            [pattern]="'text'"
            [placeHolder]="'NAME'"
            (searched)="onSearched($event)"
          >
          </app-search-text-input>
        </div>
      </div>
    </div>

    <!-- Use ngif -->
    <div [hidden]="!showListActions">
      <app-list-actions
        [showListActions]="showListActions"
        [totalItems]="meta.totalItems"
        [totalItemsSelected]="totalItemsSelected"
        [permissions]="permissions"
        (updatedItems)="onUpdatedItems($event)"
        (deletedItems)="onDeletedItems()"
      >
      </app-list-actions>
    </div>
  </form>

  <div *ngIf="meta.itemsFound > 0">
    <table class="table table-striped table-hover table-highlight-head table-vertical-align">
      <thead>
        <tr>
          <th style="width: 40px" class="align-center">
            <label class="control control-checkbox">
              <input
                type="checkbox"
                [checked]="masterCheckboxSelected"
                (change)="utilService.checkUncheckAllItems(facilities, $event)"
              />
              <div class="control-indicator"></div>
            </label>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'name'"
              (sorted)="onSorted($event)"
              >{{ 'NAME' | translate }}</app-sort-by
            >
          </th>
          <th style="width: 250px">
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'type'"
              (sorted)="onSorted($event)"
              >{{ 'TYPE' | translate }}</app-sort-by
            >
          </th>
          <th style="width: 60px" class="align-center">
            <a
              (click)="reloadFacilities()"
              title="{{ 'REFRESH' | translate }}"
              class="btn btn-xs btn-transparent"
            >
              <i class="fa fa-refresh"></i>
            </a>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let facility of facilities" id="{{ facility.id }}">
          <td class="align-center">
            <label class="control control-checkbox">
              <input
                type="checkbox"
                [checked]="facility.isSelected"
                (change)="utilService.checkUncheckItem(facilities, facility, $event)"
              />
              <div class="control-indicator"></div>
            </label>
          </td>
          <td
            (click)="selectFacility(facility)"
            [ngClass]="utilService.checkItemStatus(facility.status)"
            class="cursor"
          >
            {{ facility.name }}
          </td>
          <td
            (click)="selectFacility(facility)"
            [ngClass]="utilService.checkItemStatus(facility.status)"
            class="cursor"
          >
            <span
              *ngFor="let item of facility.type | keyvalue"
              class="label label-default"
              style="margin-right: 5px"
            >
              {{ item.key | uppercase | translate }}
            </span>
          </td>
          <td class="align-center">
            <div class="btn-group">
              <span class="dropdown-toggle btn btn-xs btn-transparent" data-toggle="dropdown">
                <i class="fa fa-ellipsis-h fa-lg"></i>
              </span>
              <ul class="dropdown-menu pull-right">
                <li *ngIf="permissions.canShow">
                  <a class="cursor" (click)="selectFacility(facility, 'edit')">
                    <i class="fa fa-pencil"></i> {{ 'EDIT' | translate }}
                  </a>
                </li>
                <li *ngIf="permissions.canUpdate">
                  <a class="cursor" (click)="changeFacilityStatus(facility)">
                    <i
                      [ngClass]="
                        facility.status === 'active' ? 'fa fa-minus-square' : 'fa fa-check-square'
                      "
                    ></i>
                    {{
                      facility.status === 'active'
                        ? ('DEACTIVATE' | translate)
                        : ('ACTIVATE' | translate)
                    }}
                  </a>
                </li>
                <li class="divider"></li>
                <li *ngIf="permissions.canDestroy">
                  <a class="cursor" (click)="deleteFacility(facility)">
                    <i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <app-table-footer
      [meta]="meta"
      (selectedPage)="onSelectedPage($event)"
      *ngIf="meta.totalPages > 1"
    ></app-table-footer>
  </div>

  <div *ngIf="meta.itemsFound === 0" class="alert alert-warning align-center" style="padding: 40px">
    <i class="fa fa-ban fa-4x"></i>
    <h3>{{ 'NO_ITEMS_FOUND' | translate }}</h3>

    <a (click)="reloadFacilities()" class="cursor">
      <i class="fa fa-times"></i> {{ 'CLEAR_SEARCH' | translate }}
    </a>
  </div>
</div>

<div
  *ngIf="facilities && meta.totalItems === 0"
  class="alert alert-info align-center"
  style="padding: 40px"
>
  <i class="fa fa-ban fa-4x"></i>
  <h5>{{ 'NO_ITEMS_FOUND' | translate }}</h5>
</div>
